import { ReportCard } from '@molecules/ReportCard/ReportCard';
import { CallToActionCard } from '@molecules/CallToAction/CallToActionCard';
import { DashboardBanner } from '@molecules/DashboardBanner/DashboardBanner';
import { SectionHeader } from '@atoms/SectionHeader/SectionHeader';
import { Link } from 'react-router-dom';
import { quickLinks } from './DashboardLinks';
import { msalInstance } from '@utils';
import { useRecentReports } from '../../../hooks/useRecentReports';
import {
  LOADING_REPORTS_MESSAGE,
  REPORT_STATUS_COLORS,
  REPORTS_WITH_STATUS_UPDATES,
} from '../../../constants';
import { WebAssistant } from '../../molecules/WebAssistant/WebAssistant';
import { RoutesList } from '../../../routes/Routes';

export const DashboardHome = () => {
  const account = msalInstance.getAllAccounts()[0];
  const firstName =
    ((account?.idTokenClaims as Record<string, unknown>)
      ?.given_name as string) || '';

  const { data, isLoading, error } = useRecentReports();
  const recentReports = data?.cases ?? [];

  return (
    <>
      <DashboardBanner userName={firstName} />
      <div className="section-horizontal-padding mb-10 py-6">
        <div className="mb-6">
          <SectionHeader title="My Dashboard" />
        </div>
        <hr className="mb-6 border-[#475372]" />

        <div className="mb-7 flex flex-col gap-4 md:w-[400px]">
          {quickLinks.map((link) => (
            <CallToActionCard
              key={link.linkText}
              linkText={link.linkText}
              externalHref={link.externalHref}
              openInNewTab={link.openInNewTab}
            />
          ))}
        </div>

        <div className="mb-7">
          <SectionHeader title="My recent reports" />
        </div>

        <div className="flex flex-col gap-6">
          {isLoading ? (
            <p className="text-body text-text-body">
              {LOADING_REPORTS_MESSAGE}
            </p>
          ) : error ? (
            <p className="text-body text-text-body">
              Failed to load reports. Please try again later.
            </p>
          ) : recentReports.length > 0 ? (
            recentReports.map((report) => (
              <ReportCard
                key={report.id}
                id={report.id}
                title={report.title}
                caseReference={report.caseReference}
                dateCreated={report.dateCreated}
                dateUpdated={report.dateUpdated}
                status={report.status}
                colors={REPORT_STATUS_COLORS}
                hideLink={!REPORTS_WITH_STATUS_UPDATES.includes(report.title)}
                previousPath={RoutesList.HOME}
              />
            ))
          ) : (
            <p className="text-body text-text-body">No reports found.</p>
          )}
        </div>

        {recentReports.length > 0 && (
          <Link
            to={RoutesList.REPORTS_LIST}
            className="text-action-link hover:text-action-link-hover text-body inline-flex items-center gap-1 pt-7 font-bold underline underline-offset-2"
          >
            View all reports
          </Link>
        )}
        <WebAssistant enableAssistant={false} />
      </div>
    </>
  );
};
